<template>
	<div class="card">
		<div class="flex info-l">
			<div class="flex between-v">
				<p class="flex">
					已跑公里:
					<span>{{sportInfo.km||0}}</span> 公里
				</p>
				<p class="flex">
					跑步时长:
					<span>{{duration||'00:00:00'}}</span>
				</p>
			</div>
			<span :class="{'success':sportInfo.status===0,'err':sportInfo.status===1}" class="flex center">{{['有效','无效'][sportInfo.status]}}</span>
		</div>
		<div class="flex end">
			<button @click="$refs.details.show(sportInfo)">查看详情</button>
		</div>
        <Details ref="details"/>
	</div>
</template>

<script>
import Details from "./details.vue";
import {secondsToString} from "@/utils/date.js";
export default {
	props: {
		sportInfo: {},
	},
	computed:{
		duration(){
			return secondsToString(this.sportInfo.duration)
		}
	},
    components:{
		Details,
	},
};
</script>


<style scoped lang="less">
.card {
	padding: 12 / @rem 15 / @rem;
	margin-bottom: 11/@rem;
	background: #ffffff;
	box-shadow: 0 3 / @rem 17 / @rem 0 rgba(143, 72, 0, 0.2);
	border-radius: 12 / @rem;
	position: relative;
	.progress {
		position: absolute;
		top: -26 / @rem;
		left: 17 / @rem;
		right: 17 / @rem;
		.card {
			height: 52 / @rem;
			.label {
				color: rgba(255, 162, 22, 1);
				&::after {
					content: " (1-4周)";
					font-size: 10 / @rem;
					color: rgba(31, 30, 29, 0.3);
				}
			}
			.num {
				font-weight: bold;
				span {
					color: rgba(255, 162, 22, 1);
				}
				&::after {
					content: attr(data-unit);
					font-size: 10 / @rem;
				}
			}
		}
	}

	p.head {
		padding: 12 / @rem 0;
		font-size: 10 / @rem;
		color: white;
	}

	.info-l {
		padding-bottom: 12 / @rem;
		border-bottom: 1 / @rem solid rgba(31, 30, 29, 0.1);
		> div {
			flex: 1;
			height: 61 / @rem;
			align-items: flex-start;
			color: rgba(31, 30, 29, 0.3);
			p {
				letter-spacing: 1 / @rem;
				span {
					font-size: 19 / @rem;
					font-weight: bold;
					color: rgba(31, 30, 29, 1);
				}
			}
		}
		> span {
			display: flex;
			width: 61 / @rem;
			height: 61 / @rem;
			border-radius: 50%;
			font-size: 19 / @rem;
			&.success {
				color: rgba(46, 204, 73, 1);
				border: 2 / @rem solid rgba(46, 204, 73, 1);
			}
			&.err {
				color: rgba(242, 65, 19, 1);
				border: 2 / @rem solid rgba(242, 65, 19, 1);
			}
		}
	}

	button {
		width: 88 / @rem;
		height: 28 / @rem;
		margin-top: 13 / @rem;
		border-radius: 15 / @rem;
		color: white;
		font-size: 10 / @rem;
		letter-spacing: 1 / @rem;
		background-color: rgba(254, 198, 51, 1);
	}
}
</style>